import { render, staticRenderFns } from "./InstallersConfig.vue?vue&type=template&id=9ca677f6&scoped=true"
import script from "./InstallersConfig.vue?vue&type=script&lang=js"
export * from "./InstallersConfig.vue?vue&type=script&lang=js"
import style0 from "./InstallersConfig.vue?vue&type=style&index=0&id=9ca677f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca677f6",
  null
  
)

export default component.exports